var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTaskNumber(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.4375,
    y: 0.227539,
    width: 46.432,
    height: 46.432,
    rx: 10,
    fill: "#FEEEEC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.293 20.588C30.6836 20.1974 30.6836 19.5643 30.293 19.1738C29.9025 18.7832 29.2694 18.7832 28.8788 19.1738L30.293 20.588ZM21.2734 28.1934L20.5663 28.9005C20.9568 29.291 21.59 29.291 21.9805 28.9005L21.2734 28.1934ZM18.418 23.9238C18.0274 23.5332 17.3943 23.5332 17.0038 23.9238C16.6132 24.3143 16.6132 24.9474 17.0038 25.338L18.418 23.9238ZM14.1484 13.9434V12.9434C13.5962 12.9434 13.1484 13.3911 13.1484 13.9434H14.1484ZM33.1484 13.9434H34.1484C34.1484 13.3911 33.7007 12.9434 33.1484 12.9434V13.9434ZM33.1484 32.9434V33.9434C33.7007 33.9434 34.1484 33.4956 34.1484 32.9434H33.1484ZM14.1484 32.9434H13.1484C13.1484 33.4956 13.5962 33.9434 14.1484 33.9434V32.9434ZM28.8788 19.1738L20.5663 27.4863L21.9805 28.9005L30.293 20.588L28.8788 19.1738ZM17.0038 25.338L20.5663 28.9005L21.9805 27.4863L18.418 23.9238L17.0038 25.338ZM14.1484 14.9434H33.1484V12.9434H14.1484V14.9434ZM32.1484 13.9434V32.9434H34.1484V13.9434H32.1484ZM33.1484 31.9434H14.1484V33.9434H33.1484V31.9434ZM15.1484 32.9434V13.9434H13.1484V32.9434H15.1484Z",
    fill: "#F8AA9E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaskNumber);
export default __webpack_public_path__ + "static/media/task-number.c59f2505eb1169d4c18bb4281170302e.svg";
export { ForwardRef as ReactComponent };